import { render, staticRenderFns } from "./TheCompareDocuments.vue?vue&type=template&id=20042955&scoped=true&"
import script from "./TheCompareDocuments.vue?vue&type=script&lang=js&"
export * from "./TheCompareDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TheCompareDocuments.vue?vue&type=style&index=0&id=20042955&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20042955",
  null
  
)

export default component.exports